import React, { useContext, useState, useEffect } from "react"
import { CalendarEventContext } from "./CalendarEventContext"
import CalendarWeekday from "./CalendarWeekday"
import CalendarWeekdayTitles from "./CalenderWeekdayTitles"
import CalendarWeekdayFiller from "./CalendarWeekdayFiller"

import {
  getCalendarFillerDays_before,
  getDaycount_Month,
  previousMonth,
  nextMonth
} from "../util/calendarutil"

const monthsLookup = ["--", "Januar", "Februar", "März", "April",
  "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]

function Calendar({ month, year }) {
  const { currentDefaultMonth } = useContext(CalendarEventContext)
  const [currentMonth, setCurrentMonth] = useState(currentDefaultMonth) // [year, month]

  useEffect(()=>{
    setCurrentMonth(currentDefaultMonth)
  },[currentDefaultMonth])
  
  function displayPreviousMonth() {
    setCurrentMonth(prev => previousMonth(...prev))
  }
  function displayNextMonth() {
    setCurrentMonth(prev => nextMonth(...prev))
  }

  const daycountmonth = getDaycount_Month(...currentMonth)
  const fillerdays_before = getCalendarFillerDays_before(currentMonth[0], currentMonth[1])
  const fillerdays_after = 42 - fillerdays_before - daycountmonth

  let allDays = []
  for (let i = 1; i <= daycountmonth; i++) {
    let key = `${currentMonth[0]}-${currentMonth[1]}-${i}`
    let tempdatearr = [...currentMonth, i]
    allDays.push(<CalendarWeekday key={key} className="DAY" dayofmonth={i} datearr={tempdatearr} />)
  }

  const text_ingame = `Ingamezeit ${monthsLookup[currentDefaultMonth[1]]} ${currentDefaultMonth[0]}`
  const text_currentMonth = `${monthsLookup[currentMonth[1]]} ${currentMonth[0]}`

  return (

    <div className="ncalendar">
      <div className="ncal-title">{text_ingame}</div>
      <div className="ncal-title">{text_currentMonth}</div>

      <div className="ncal-container">
        <CalendarWeekdayTitles />
        <CalendarWeekdayFiller fillercount={fillerdays_before} />
        {allDays}
        <CalendarWeekdayFiller fillercount={fillerdays_after} />
      </div>
      <div className="ncal-btn-container" >
        <div className="ncal-btn ncal-btn__left" onClick={displayPreviousMonth}>{"➤"}</div>
        <div className="ncal-btn" onClick={displayNextMonth}>{"➤"}</div>
      </div>
    </div>

  )
}

export default Calendar

